import React from 'react';

import firebase from 'firebase';
import 'firebase/firestore';
import Button from '@material-ui/core/Button'

var config = {
    apiKey: "AIzaSyCCcPofhlO_CyP0XbCzSbaxHO-ByVoIhNg",
    authDomain: "sbahn-stuttgart-firebase.firebaseapp.com",
    databaseURL: "https://sbahn-stuttgart-firebase.firebaseio.com",
    projectId: "sbahn-stuttgart-firebase",
    storageBucket: "sbahn-stuttgart-firebase.appspot.com",
    messagingSenderId: "1054401432419"
  };


firebase.initializeApp(config);

// Get a reference to the database service
//var db = firebase.firestore();

const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);


//var lightstatus = db.collection("lightstatus").doc(epochsec);

var lightstatus = firestore.collection("stationStatus").doc("TSC");




var getDoc = lightstatus.get()
    .then(doc => {
        if (!doc.exists) {
            console.log('No LightStatus document!');
        } else {
            console.log('Document data:', doc.data());
            console.log("routingIdentifier: " + doc.data().routingIdentifier);
            console.log("secondsSinceEpoch: " + doc.data().secondsSinceEpoch);
        }
    })
    .catch(err => {
        console.log('Error getting document', err);
    });




export default class LightTracker extends React.Component {
    state = {
        version: "0.3",
        isTrackingDisabled: true,
        strSignal: "",
        buttonText: "Click to Monitor Lights",
        timeSignal: "",
        eventcode: "",
        eventstation: "",
    }

    handleLightStateClick = () => {   
        console.log('handleLightStateClick');
        if (this.state.isTrackingDisabled){
            this.setState({isTrackingDisabled: false})
            this.setState({buttonText : "STOP MONITORING"})

            this.setState({isTrackingDisabled: false})
            this.setState({strSignal: "UNKNOWN" })
            lightstatus = firestore.collection("stationStatus").doc("TSC");
            getDoc = lightstatus.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such document!');
                        this.setState({strSignal : "UNKNOWN"})
                    } else {
                        console.log('Document data:', doc.data());
                        console.log("routingIdentifier: " + doc.data().routingIdentifier);
                        console.log("secondsSinceEpoch: " + doc.data().secondsSinceEpoch);                    // console.log("Longitude: " + doc.data().longitude);
                        this.setState({strSignal : doc.data().strSignal})
                        var dateSignal  = new Date(0);
                        dateSignal.setUTCSeconds(doc.data().secondsSinceEpoch);
                        var strDate = dateSignal.getDate() + "-" + dateSignal.getMonth() + "-" + dateSignal.getFullYear() + "   " + dateSignal.getHours() + ":" + dateSignal.getMinutes()
                        this.setState({timeSignal : strDate});
                        this.setState({eventcode : doc.data().eventCode})
                        this.setState({eventstation : doc.data().eventStation})


                    }
                })
                .catch(err => {
                    console.log('Error getting document', err);
            });
            this.observer = lightstatus.onSnapshot(docSnapshot => {
                console.log("routingIdentifier: " + docSnapshot.data().routingIdentifier);            // if the lat and long have changed then update the map - BUT NOT IF 0
                this.setState({strSignal : docSnapshot.data().strSignal})
                var dateSignal  = new Date(0);
                dateSignal.setUTCSeconds(docSnapshot.data().secondsSinceEpoch);
                var strDate = dateSignal.getDate() + "-" + dateSignal.getMonth() + "-" + dateSignal.getFullYear() + "   " + dateSignal.getHours() + ":" + dateSignal.getMinutes()
                this.setState({timeSignal : strDate});
                this.setState({eventcode : docSnapshot.data().eventCode})
                this.setState({eventstation : docSnapshot.data().eventStation})

            }, err => {
                console.log(`Encountered error: ${err}`);
            });

         }else{
            this.setState({buttonText : "Click to Monitor Lights"})
            this.observer();
            this.setState({isTrackingDisabled: true})
         }
        
     }

     


    render(){
        return (
            <div>
            <br></br>
            <Button variant="contained" color="primary" onClick={this.handleLightStateClick}>
            {this.state.buttonText}
            </Button>
            <br></br>
            <b>Last signal time: {this.state.timeSignal} </b>
            <br></br>
            <b>Signal : {this.state.strSignal} </b>
            <br></br>
            <b>Event code : {this.state.eventcode} </b>
            <br></br>
            <b>Event Station : {this.state.eventstation} </b>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Component/LightTracker.js